<template lang="pug">
  .columns.is-vcentered
    .column.is-3-desktop
    .login.column.is-6
      section.section
        img.login-logo(:src="ecoinventLogo")
        .content
          h3 {{ $t('Data Converter Registration') }}
        form(@submit.prevent="submitRegistration")
          b-field(:label="$t('First Name')")
            b-input(v-model="firstName" @input="clearError" :disabled="submitting || done")
          b-field(:label="$t('Last Name')")
            b-input(v-model="lastName" @input="clearError" :disabled="submitting || done")
          b-field( :label="$t('E-Mail')" :message="errors.email" :type="{'is-danger': !!errors.email}" )
            b-input(type="email" v-model="email" @input="$set(errors, 'email', null)" :disabled="submitting || done")
          b-field(:label="$t('Password')" :message="errors['password']" :type="{'is-danger': !!errors.password}")
            b-input(type="password" v-model="password" icon="key"
            @input="$set(errors, 'password', null)" :disabled="submitting || done")
          b-field(:label="$t('Repeat Password')" :message="errors['password2']"
          :type="{'is-danger': !!errors.password2}")
            b-input(type="password" v-model="password2" icon="key"
            @input="$set(errors, 'password2', null)" :disabled="submitting || done")
          b-field( :label="$t('EULA')" :message="errors.eula" :type="{'is-danger': !!errors.eula}" )
            b-checkbox(v-model="eula" @input="$set(errors, 'eula', null)" :disabled="submitting || done")
              | {{ $t('I accept the ecoinvent') }}
              a(href="https://ecoinvent.org/the-ecoinvent-database/terms-of-use/" target="_blank")
                |
                | EULA
          b-field( :label="$t('Privacy Policy')" :message="errors.privacy" :type="{'is-danger': !!errors.privacy}" )
            b-checkbox(v-model="privacy" @input="$set(errors, 'privacy', null)" :disabled="submitting || done")
              | {{ $t('I accept the ecoinvent Privacy Policy') }}
              a(href="https://www.ecoinvent.org/privacy-policy-eula/" target="_blank")
                |
                | Privacy Policy
          transition(type="fade")
            b-message(v-if="done" key="done" type="is-success" has-icon)
              | {{ $t('Thank you for registering!')}}
              <br>
              | {{ $t('Please check your email inbox to complete the registration.') }}
          .has-text-centered
            input.button.is-vcentered.is-primary.is-outlined( type="submit"
            :value="$t('Register')" :disabled="submitting || done || !privacy || !eula")
    .column.is-3-desktop
</template>

<script>
import { register } from '../utils/api'

export default {
  name: 'Register',
  data() {
    return {
      privacy: false,
      eula: false,
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      password2: '',
      errors: {},
      submitting: false,
      done: false,
      ecoinventLogo: require('../assets/ecoinvent Brand mark.png')
    }
  },
  methods: {
    submitRegistration() {
      if (this.submitting || this.done || !this.privacy || !this.eula) {
        return
      }

      if (this.password !== this.password2) {
        this.errors.password2 = this.$t('The passwords you entered do not match.')
      } else {
        this.submitting = true
        register(this.firstName, this.lastName, this.email, this.password)
          .then(() => {
            this.done = true
            this.submitting = false
          })
          .catch((error) => {
            this.errors = error.response.data
            this.submitting = false
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .button {
    margin-top: 20px;
    margin-bottom: 20px;
    min-width: 150px;
  }

  .login-logo {
    margin: 0 2rem 5rem;
    max-height: 100px;
  }

  .is-danger {
    color: #e01a1a;
  }
</style>



// WEBPACK FOOTER //
// src/components/Register.vue